<template>
  <div class="body-wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link
          :to="`/businesses_change`"
          :key="`businesses`"
          :name="$store.state.text['change_school']"
          :icon="`ti-arrow-circle-left`"
        />

        <sidebar-link
          :to="`/dashboard`"
          :key="`dashboard`"
          :name="$store.state.text['main']"
        />

        <sidebar-link
          v-for="(route, key) in routes" v-if="route.id != 30"
          :to="`/${route.path}`"
          :key="key"
          :name="route.title"
        />

        <!--   :icon="route.icon"-->
        <!--       :icon="`ti-power-off`"-->
        <li class="nav-item">
          <a
            class="nav-link"
            :href="`https://kundalik.com/teachers`"
            target="_blank"
            ><b>Kundalik</b></a
          >
        </li>

        <sidebar-link
          :to="`/quit`"
          :key="`quit`"
          :name="$store.state.text['quit']"
        />
      </template>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <svg class="svg-angle svg-angle-1" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <svg class="svg-angle svg-angle-2" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <!-- <svg class="svg-angle svg-angle-3" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg> -->
      <!-- <svg class="svg-angle svg-angle-4" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg> -->
      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["routes"]),
  },
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>

<style>
.logout {
  border: none;
  box-shadow: none;
  width: 100%;
  position: absolute;
  bottom: 30px;
  background: transparent;
  color: #fff;
  font-size: 20px;
  text-align: left;
  padding: 10px 25px;
}
</style>
